/*
PM 2021-07-29
KONCEPCJA KOMPONENTU
================

Komponent mapy

================

Kontener mapy to komponent MapContainer (zaimportowany z biblioteki react-leaflet)
Propsy komponentu MapContainer:
* center - wspolrzedne srodka mapy, tylko do inicjacji, brane z propsa obszar (od komponentu rodzica MapContainer)

Wybor warstwy (stylu) mapy to komponent LayersControl (zaimportowany z biblioteki react-leaflet)
Warstwy do wyboru to komponenty LayersControl.BaseLayer
Props checked mowi, ktora warstwa jest wyswietlana domyslnie
Warstwy sa renderowane przez komponenty TileLayer (zaimportowany z biblioteki react-leaflet)
Mozna je nakladac na siebie

Na mapie sa renderowane obiekty noclegowe jako pineski - komponenty Marker (zaimportowany z biblioteki react-leaflet)
Komponent Tooltip to dymek pojawiajacy sie po najechaniu na pineske (zaimportowany z biblioteki react-leaflet)
Style markerow brane z propsa - funkcji getIcon (od komponentu rodzica MapContainer)

================
importowane komponenty:

*/

import * as React from 'react';

import {
    MapContainer, TileLayer, Marker, Tooltip, LayersControl,
    ZoomControl, ScaleControl, Circle, Pane, Polygon, Polyline, useMap
} from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import L, { TileErrorEvent, LayersControlEvent } from 'leaflet';

import { connect } from 'react-redux';

import { AppState, IPageState } from '../../appredux';
import { tiles } from './mapData';
import { Info } from '../../api';

import Routing from "./Routing";
import Search from "./Search";
import './Routing.css';
import './Map.css';
import { Fab } from '@material-ui/core';
import { MapData } from './MapContainer';

import 'leaflet-geosearch/dist/geosearch.css';


//PM 2021-11-30
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface MapProps {
    page: IPageState,
    contact: Info,
    map: MapData,

    distance: number,
    address: string,
    getIcon: (color: number) => L.Icon | undefined, //pobieranie koloru pineski
    latObiekt: number,                                    //szer. geogr.
    lngObiekt: number,                                    //dl. geogr.
    latClient: number,                                    
    lngClient: number,                                    
    bounds: L.LatLngBoundsExpression,               //początkowe granice mapy
    tooltip: string,                                //opis przy pinesce
    tileErrors: string[],
    tileName: string,
    addTileError: (aName: string) => Promise<void>,
    setTileName: (aName: string) => Promise<void>,
    update: () => void
}

interface MapState {
    //isMapInit: boolean,
    mode: number,   // 0 - odległość, 1 - trasa
    //refresh: number
}


class Map extends React.Component<MapProps, MapState>  {
    mapRef: any; //React.RefObject<L.Map>; useRef(null)


    constructor(props: MapProps) {
        super(props, {});
        this.mapRef = React.createRef() //as React.RefObject<L.Map>
        //this.mapRef = React.useRef(null) //as React.RefObject<L.Map>
        this.state = {
            //isMapInit: false,
            mode: 0,
            //refresh: 0
        }

    //     setInterval(() => {
    //         let input1 = document.getElementsByClassName("glass")
    //   console.log(input1)
    //   if(input1.length >0 ){
    //     input1[0].setAttribute("value", "Rzeszów, ")
    //   }
    //     }, 300);
    }

    // componentDidUpdate(prevProps: MapProps, prevState: MapState) {
    //     console.log(this.mapRef)
    //     if(this.props.map.obiektGPS !== prevProps.map.obiektGPS){
    //         //if(this.mapRef){
    //             this.setState({refresh: this.state.refresh + 1})
    //             //console.log(this.mapRef)
    //             //this.mapRef.current.setView(new L.LatLng(40.737, -73.923), 8);
    //         //}
    //     }
      
    //   }

    //PM 2021-11-04 zrezygnowano
    // mapPlaceholder = () => {
    //     const { classes } = this.props

    //     return (
    //         <div className={classes.frame} style={{ width: '100%', height: '100%' }}>
    //             <span className={classes.helper}></span>
    //             <img
    //                 className={classes.img}
    //                 style={{ maxWidth: '1000px', width: window.innerWidth > 600 ? '' : (window.innerWidth - 30) + 'px' }}
    //                 src="img/map-placeholder.jpg"
    //                 alt="Brak mapy"
    //             />
    //         </div>
    //     )
    // }

    //PM 2021-10-19
    baseLayerChange = async (event: LayersControlEvent) => {
        await this.props.setTileName(event.name)
    }

    //raz przy tworzeniu mapy
    //PM 2021-10-19
    whenCreated = (map: any) => {
        //console.log(map)
        map.target.on('baselayerchange', this.baseLayerChange);
        this.mapRef.current = map
        //this.setState({
        //    isMapInit: true
        //  });
    }

    //PM 2021-11-30
    tooltip = () => {
        //const wspolrzedne = this.props.contact.kontaktGps.split(' ');
        //const wspolrzedne = this.props.map.obiektGPS.split(' ');

        //if (wspolrzedne.length === 2)
            return (
                <React.Fragment>
                    {this.props.tooltip}
                    <br />
                    {/* {this.props.contact.kontaktGps} */}
                    {this.props.map.obiektGPS}
                </React.Fragment>
            )
        // else
        //     return (
        //         <React.Fragment>
        //             Wawel
        //             <br />
        //             {`${this.props.lat}N ${this.props.lng}E`}
        //         </React.Fragment>
        //     )
    }

    tooltipClient = () => {
        let distanceKM = (this.props.distance / 1000).toFixed(1) + " km"

        return (
            <React.Fragment>
                {this.props.address}
                <br />
                {distanceKM}
            </React.Fragment>
        )
    }

    changeMode = () => {
        this.setState({mode: this.state.mode ? 0 : 1 })
    }

    update = () => {
       this.props.update()
    }

    //główna pętla
    //PM 2021-11-30
    //obsługa braku wspolrzednych do mapy
    render = () => {
        let selectedClient = this.props.latObiekt !== 0 && this.props.lngObiekt !== 0
                          && this.props.latClient !== 0 && this.props.lngClient !== 0   
                          
                          
// maxHeight: window.innerWidth > 600 ? '' : window.innerWidth + 'px'
        return (
            <MapContainer 
                bounds={this.props.bounds}
                zoomSnap={0.1} zoomDelta={0.5}
                style={{ height: (window.innerHeight - 29) + 'px', }}
                zoomControl={false}
                //whenCreated={this.whenCreated}
                //whenCreated={(map: any) => {
                //    console.log("The underlying leaflet map instance:", map)
                //  }}
                whenReady={ (mapInstance: any) => { this.whenCreated(mapInstance) }} //this.mapRef.current =mapInstance
                // ref={m => {
                //     this.leafletMap = m;
                //   }}
            >
                {/* <SetViev refresh={this.state.refresh} lat={this.props.lat} lng={this.props.lng}/> */}

                <LayersControl >
                    {tiles.filter(tile => !this.props.tileErrors.includes(tile.name)).map((tile, index) => {
                        return (
                            <LayersControl.BaseLayer key={tile.name} checked={this.props.tileErrors.length && index === 0 ? true : tile.checked} name={tile.name}>
                                {/* {<React.Fragment> */}
                                <TileLayer
                                    attribution={tile.attribution}
                                    url={tile.url}
                                    eventHandlers={{
                                        tileerror: async (event: TileErrorEvent) => {
                                            if (!this.props.tileErrors.includes(tile.name))
                                                await this.props.addTileError(tile.name)
                                        }
                                    }}
                                />
                                {/* {this.props.tileErrors.includes(tile.name) ?
                                        this.mapPlaceholder() : null}
                                </React.Fragment>} */}
                            </LayersControl.BaseLayer>
                        )
                    })}
                    {/* <LayersControl.BaseLayer name="Voyager Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark Znaczniki">
                        <LayerGroup>
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                            />
                            <TileLayer
                                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                url="https://{s}.basemaps.cartocdn.com/rastertiles/light_only_labels/{z}/{x}/{y}.png"
                            />
                        </LayerGroup>
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Voyager bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Dark bez znaczników">
                        <TileLayer
                            attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer> */}
                </LayersControl>

                <ZoomControl position="topright" />
                <ScaleControl position="bottomleft" />

                {selectedClient ?
                    <>
                        <Circle center={[this.props.latObiekt, this.props.lngObiekt]} fillColor={"green"} radius={3000} color="green" />
                        <Circle center={[this.props.latObiekt, this.props.lngObiekt]} fillColor={"yellow"} radius={6000} color="yellow" />
                        <Circle center={[this.props.latObiekt, this.props.lngObiekt]} fillColor={"red"} radius={10000} color="red" className="opacity" />
                    </>
                : null}
                
                {this.state.mode === 0 && selectedClient ?     
                <Polyline pathOptions={{ color: 'green' }}
                    positions={[
                        [this.props.latObiekt, this.props.lngObiekt],
                        [this.props.latClient, this.props.lngClient],
                    ]} />

                : null} 

                {/* {<Search map={this.mapRef} mapProp={this.props.map} contact={this.props.contact}/> }   */}
                    
                { this.state.mode === 1 && selectedClient ? 
                    <Routing map={this.mapRef} latRestaurant={this.props.latObiekt} lngRestaurant={this.props.lngObiekt} latClient={this.props.latClient} lngClient={this.props.lngClient} />     
                 : null} 
            
                <Marker
                    position={[this.props.latObiekt, this.props.lngObiekt]}
                    icon={this.props.getIcon(1)}
                >
                    <Tooltip>
                        {this.tooltip()}
                    </Tooltip>
                </Marker>
                    
                {selectedClient ?
                    <Marker
                        position={[this.props.latClient, this.props.lngClient]}
                        icon={this.props.getIcon(2)}
                    >
                        <Tooltip>
                            {this.tooltipClient()}
                        </Tooltip>
                    </Marker>
                    : null} 
                
                    {/* {this.props.tileErrors.includes(this.props.tileName) ?
                    null
                    :
                    (
                        <React.Fragment>
                            <ZoomControl position="topright" />
                            <ScaleControl position="bottomleft" />
                            <Marker
                                position={[this.props.lat, this.props.lng]}
                                icon={this.props.getIcon(1)}
                            >
                                <Tooltip>
                                    {this.tooltip()}
                                </Tooltip>
                            </Marker>
                        </React.Fragment>
                    )} */}

                {selectedClient ?
                    <Fab
                        className="mapFab"
                        style={{  }}
                        color="primary"
                        //aria-label="dodaj"
                        onClick={() => this.changeMode()}
                    >
                       {this.state.mode === 0 ? "trasa" : "linia"}
                    </Fab> : null}

                {selectedClient ?
                    <Fab
                        className="mapFabKoniec"
                        style={{}}
                        color="primary"
                        //aria-label="dodaj"
                        onClick={() => this.update()}
                    >
                        {"koniec"}
                    </Fab> : null}
            </MapContainer>
        );
    }
}

// const styles = (theme: Theme) => ({
//     frame: {
//         whiteSpace: 'nowrap' as 'nowrap', /* This is required unless you put the helper span closely near the img */
//         textAlign: 'center' as 'center',
//     },
//     helper: {
//         display: 'inline-block',
//         height: '100%',
//         verticalAlign: 'middle'
//     },
//     img: {
//         verticalAlign: 'middle',
//         maxHeight: '447px',
//         maxWidth: '1000px'
//     }
// });

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
    contact: state.pageState.contact,
    map:  state.pageState.map
});

export default connect(mapStateToProps)(Map);

// interface  setVievProps {
//     refresh: number,
//     lat: number,
//     lng: number,
// }

// function SetViev(props:setVievProps) {
//     console.log("qqqqqqqqqqqqqqqqqqqqqqqqqq")
//     const map = useMap() as L.Map
//     map.setView([props.lat, props.lng],)
//     return null
//   }